import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { closeModalWithNavigation } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import Panel from "../../components/Panel";
import AlertInsert from "../../components/AlertInsert";
import useIsLoggedInUserType from "../../../shared/hooks/useIsLoggedInUserType";
import { USER_TYPE_MAP } from "../../../shared/utility";

const GenericError = ({
  headerText = "It looks like something has gone wrong",
  bodyText = "Please click the button below to continue or if the problem persists, please contact us on 01676 571 098",
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const specialPaths = ["/vendor/vehicle/"]; // Add more special paths as needed in the future
  const containsSpecialPath = (pathname, paths) => {
    return pathname && paths.some((path) => pathname.includes(path));
  };

  const buyerUser = useIsLoggedInUserType(USER_TYPE_MAP.Buyer);

  const onBackToSearchClick = () => {
    if (buyerUser) {
      return dispatch(closeModalWithNavigation("/", navigate));
    }

    if (containsSpecialPath(location?.pathname, specialPaths)) {
      // just close the modal as we want to navigate to the same page instead of going to previous page
      return dispatch(closeModalWithNavigation(location.pathname, navigate));
    }

    return navigate(-1);
  };

  const changeButtonText = buyerUser
    ? "Return to search"
    : "Return to previous page";

  return (
    <ModalInsert>
      <Panel padding="NONE">
        <AlertInsert
          action={onBackToSearchClick}
          headerText={headerText}
          bodyText={bodyText}
          buttonText={changeButtonText}
        />
      </Panel>
    </ModalInsert>
  );
};

export default GenericError;
